class ReviewRequest {
  static readByProfessionalId = {
    professionalId: null
  };
}

export default ReviewRequest;
